<script setup lang="ts">
import type { Schemas } from '#shopware'

interface ProductLiterPriceProps {
    product: Schemas['Product']
    productNumber?: string
}

const props = defineProps<ProductLiterPriceProps>()

const { getFormattedPrice } = usePrice()

const literPrices: Record<string, number> = {
    '950990000004': 199.75,
    '950990000001': 299.5,
    '950990000002': 299.5,
    '950990000003': 299.5,
    '951000000064': 99.50,
    '951000000009': 42.38,
    '951000000011': 56.50,
    '951000000020': 79.75,
    '951000000019': 46.50,
    '951000000018': 64.75,
    '951000000015': 64.75,
    '951000000012': 64.75,
    '951000000014': 43.16,
    '951000000021': 64.75,
    '951000000022': 69.75,
    '951000000023': 69.75,
    '951000000046': 89.50,
    '951000000045': 89.50,
    '951000000044': 89.50,
    '951000000062': 129.5,
    '951000000047': 60.65,
    '951000000038': 159.33,
    '951000000049': 119.33,
    '951000000072': 109.50,
    '951000000016': 109.50,
    '951000000048': 89.50,
    '951000000017': 64.75,
    '951000000065': 139.50,
    '951000000066': 139.50,
    '951000000068': 139.50,
    '951000000037': 119.00,
    '951000000036': 119.00,
    '951000000033': 119.00,
    '951000000029': 119.00,
    '951000000028': 119.00,
    '951000000027': 119.00,
    '951000000067': 139.50,
}

const literPrice = computed(() => {
    const productNumber = props.productNumber ?? props.product.productNumber
    if (!productNumber || !(productNumber in literPrices)) return null
    return literPrices[productNumber]
})
</script>

<template>
    <div v-if="literPrice !== null" class="text-sm text-center text-neutral">
        {{ getFormattedPrice(literPrice) }}/l
    </div>
</template>